import { render, staticRenderFns } from "./KIconButton.vue?vue&type=template&id=8ae23cf8&"
import script from "./KIconButton.vue?vue&type=script&lang=js&"
export * from "./KIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports